import { render } from "./UserProfileButtonSvg.vue?vue&type=template&id=10901d3e"
import script from "./UserProfileButtonSvg.vue?vue&type=script&lang=js"
export * from "./UserProfileButtonSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__